import { AxiosResponse } from 'axios';
import { GetPackageManagementResponse, IGetPackageDetailsResponse, QuoteResponseCount } from '@/main/models/response';
import { QuoteCountStatusRequest, QuoteFilterRequest } from '@/main/models/request';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IPackingTrackingApi {
  abstract getPackageManagement(
    request: QuoteFilterRequest
  ): Promise<AxiosResponse<PaginationResponse<GetPackageManagementResponse>>>;

  abstract getPackageDetails(
    guidPackingTracking: string
  ): Promise<
    AxiosResponse<Result<IGetPackageDetailsResponse>>
  >;

  abstract countPackageStatus(
    request: QuoteCountStatusRequest
  ): Promise<AxiosResponse<Result<QuoteResponseCount[]>>>;
}

